"use client";

import { GE } from ".constants/gtmEvents";
import { PATH_BLOG } from ".constants/links";
import { PORTALS } from ".constants/portals";
import { InfoBoxV4, usePortalContext } from "@cloai/uikit";
import { useLocale } from "next-intl";
import { MouseEvent, useCallback } from "react";

import { useFlag, LanguageCode } from "@/components/hooks/useLanguage";
import { usePathname } from "@/i18n";
import { useGTMContext } from "@/providers";

export const HeaderLangButton = () => {
  const { openPortal } = usePortalContext();
  const { sendGTM } = useGTMContext();

  const locale = useLocale();
  const pathname = usePathname();

  const flag = useFlag();

  const isHideLangButton =
    process.env.NEXT_PUBLIC_IS_CN || pathname.includes(PATH_BLOG);

  const openLanguageModal = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      sendGTM({ event: GE.CHOOSE_LANGUAGE_HEADER });
      openPortal(PORTALS.CHANGE_LANG);
    },
    [openPortal, sendGTM],
  );

  if (isHideLangButton) {
    return null;
  }

  return (
    <div className="hide md:block">
      <InfoBoxV4
        iconLeft={flag(locale as LanguageCode)}
        text={locale.toUpperCase()}
        onClick={openLanguageModal}
      />
    </div>
  );
};
